import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-scroll-top',
    templateUrl: './scroll-top.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ScrollTopComponent implements OnInit {
    constructor() { }
    ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/scroll-top/scroll-top.component.ts